<template>
    <div class="date-picker">
        <div class="date-input">
            <input type="date" :clearable="false" id="start-date" v-model="startDate"
                @change="handleChange($event, 'start')" />
        </div>
        <div class="date-separator">-</div>
        <div class="date-input">
            <input type="date" :clearable="false" id="end-date" v-model="endDate" @change="handleChange($event, 'end')" />
        </div>
    </div>
</template>
  
<script>
import moment from 'moment';
export default {
    data() {
        return {
            startDate: '2023-03-08',
            endDate: '2023-03-08'
        };
    },
    mounted() {
        this.startDate = moment(new Date().getTime() - 3600 * 1000 * 24 * 1).format('YYYY-MM-DD');
        this.endDate = moment(new Date().getTime()).format('YYYY-MM-DD');
        console.log(this.startDate, this.endDate, 'this.startDatethis.endDate');
    },
    methods: {
        handleChange(e, type) {
            // do something when the date inputs change
            this.$emit('getAlarmData', [this.startDate, this.endDate]);
        }
    }
};
</script>
  
<style>
.date-picker {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: end;
}

.date-input {
    display: flex;
    align-items: center;
}

#start-date,
#end-date {
    padding: 5px;
    font-size: 14px;
    border: none;
    outline: none;
    box-sizing: border-box;
    height: 30px;
}

.date-separator {
    height: 30px;
    line-height: 30px;
    background-color: #fff;
}
</style>